/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchUserOperatorSelectionsRequestActionCreator, deleteUserOperatorSelectionRequestActionCreator } from '../../../user/redux/actions/UserActions';
import { departureMailProcessingCenterCheckedActionCreator } from '../redux/actions/DeparturePostalOperatorActions';
import { arrivalMailProcessingCenterCheckedActionCreator } from '../redux/actions/ArrivalPostalOperatorActions';
import OperatorTypes from '../../../common/redux/actions/types/OperatorTypes';
import Icons from '../../../../core/modules/common/components/Icons';
import DeleteModal from '../../../common/components/DeleteModal';

function operatorSelectorSelector(props, state) {
  switch (props.operatorType) {
    case OperatorTypes.DEPARTURE:
      return state.postalOperatorSelector.departure;
    case OperatorTypes.ARRIVAL:
      return state.postalOperatorSelector.arrival;
    default:
      return state.postalOperatorSelector.departure;
  }
}

const mapStateToProps = (state, props) => ({
  selections: operatorSelectorSelector(props, state).selections,
});

class OperatorSelectionSidebarContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DEPARTURE: { activeSelection: 'Your last selection' },
      ARRIVAL: { activeSelection: 'Your last selection' },
      showDeleteSelectionModal: false,
      name: '',
    };
  }

  componentDidMount() {
    const {
      operatorType,
    } = this.props;
    this.props.fetchUserOperatorSelectionsRequestActionCreator(operatorType);
  }

  onCloseModal = () => {
    this.setState({
      showDeleteSelectionModal: false,
    });
  };

  applySelection = (e, selection) => {
    if (this.props.operatorType === OperatorTypes.DEPARTURE) {
      this.props
        .departureMailProcessingCenterCheckedActionCreator(selection.operatorCodes, this.props.report);
    } else if (this.props.operatorType === OperatorTypes.ARRIVAL) {
      this.props
        .arrivalMailProcessingCenterCheckedActionCreator(selection.operatorCodes, this.props.report);
    }
    this.setState({
      [this.props.operatorType]: { activeSelection: selection.name },
    });
  };

  openDeleteSelectionModal = (e, selection) => {
    this.setState({
      showDeleteSelectionModal: true,
      name: selection.name,
    });
  };

  deleteSelection = () => {
    this.props.deleteUserOperatorSelectionRequestActionCreator(this.state.name);
    this.onCloseModal();
  };

  render() {
    const {
      selections,
      operatorType,
    } = this.props;
    return (
      <div className="operator-sidebar-div">
        <div className="selection-title">
          <FormattedMessage
            tagName="h5"
            id="app.selection.list.title.label"
            values={{ operatorType }}
          />
        </div>
        {selections && selections.length > 0 ? (
          <div className="user-selections">
            {this.state.showDeleteSelectionModal &&
              <DeleteModal
                headerFormattedMessageId="app.warning.delete.save.operator.selection"
                onCloseModal={this.onCloseModal}
                deleteSelection={this.deleteSelection}
              />
              }
            <ul>
              { selections
                  .filter(selection => selection.scope === 'USER' && selection.name !== 'Your last selection')
                  .map(selection => (
                    <li
                      key={selection.name}
                      onClick={e => this.applySelection(e, selection)}
                      className={this.state[operatorType].activeSelection === selection.name ? 'active' : ''}
                    >
                      <button
                        className="delete-icon"
                        key={selection.name}
                        onClick={e => this.openDeleteSelectionModal(e, selection)}
                      >
                        <Icons.Custom name="trash-o" />
                      </button>
                      {selection.name}
                    </li>
                  )) }
            </ul>
            <ul className="global-ul">
              { selections
                  .filter(selection => selection.scope === 'GLOBAL' && selection.name !== 'Your last selection')
                  .map(selection => (
                    <li
                      key={selection.name}
                      onClick={e => this.applySelection(e, selection)}
                      className={this.state[operatorType].activeSelection === selection.name ? 'active' : ''}
                    >
                      <button
                        className="global-icon"
                        key={selection.name}
                        onClick={e => this.openDeleteSelectionModal(e, selection)}
                      >
                        <Icons.Custom name="trash-o" />
                      </button>
                      {selection.name}
                    </li>
                  )) }
            </ul>
          </div>
          ) :
          <FormattedMessage id="app.selection.list.empty" />
        }
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchUserOperatorSelectionsRequestActionCreator,
  deleteUserOperatorSelectionRequestActionCreator,
  departureMailProcessingCenterCheckedActionCreator,
  arrivalMailProcessingCenterCheckedActionCreator,
}, dispatch);

OperatorSelectionSidebarContainer.propTypes = {
  report: PropTypes.shape({
    reportDirections: PropTypes.arrayOf(PropTypes.string),
    locationType: PropTypes.string,
  }),
  selections: PropTypes.arrayOf(PropTypes.shape({
    scope: PropTypes.string,
    name: PropTypes.string.isRequired,
    operatorCodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  })),
  fetchUserOperatorSelectionsRequestActionCreator: PropTypes.func,
  deleteUserOperatorSelectionRequestActionCreator: PropTypes.func,
  departureMailProcessingCenterCheckedActionCreator: PropTypes.func,
  arrivalMailProcessingCenterCheckedActionCreator: PropTypes.func,
  operatorType: PropTypes.string,
};

export const ConnectedOperatorSelectionSidebarContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(OperatorSelectionSidebarContainer);

export default (ConnectedOperatorSelectionSidebarContainer);
